var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccurateImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 88,
    viewBox: "0 0 103 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1071 70.8772C44.1271 70.4058 44.9081 70.2185 45.1397 70.6297C46.2268 72.5596 48.0815 75.3979 50.1859 76.6885C52.2904 77.9791 55.661 78.3452 57.8741 78.4391C58.3456 78.4591 58.5328 79.2401 58.1217 79.4717C56.1917 80.5589 53.3534 82.4135 52.0629 84.5179C50.7723 86.6224 50.4062 89.9931 50.3122 92.2062C50.2922 92.6776 49.5113 92.8648 49.2797 92.4537C48.1925 90.5238 46.3379 87.6855 44.2334 86.3949C42.129 85.1043 38.7583 84.7382 36.5452 84.6443C36.0737 84.6243 35.8865 83.8433 36.2976 83.6117C38.2276 82.5245 41.0659 80.6699 42.3565 78.5655C43.647 76.461 44.0131 73.0903 44.1071 70.8772Z",
    fill: "url(#paint0_linear_1_141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.3629 66.5853C79.3266 66.1148 78.5032 65.9174 78.2575 66.3203C77.5181 67.5327 76.4517 68.996 75.2665 69.7229C74.0812 70.4497 72.2935 70.7367 70.8776 70.8461C70.4071 70.8824 70.2097 71.7057 70.6126 71.9514C71.825 72.6909 73.2883 73.7572 74.0152 74.9425C74.742 76.1277 75.029 77.9155 75.1383 79.3314C75.1747 79.8019 75.998 79.9992 76.2437 79.5964C76.9832 78.3839 78.0495 76.9207 79.2348 76.1938C80.42 75.4669 82.2078 75.1799 83.6237 75.0706C84.0942 75.0343 84.2915 74.2109 83.8887 73.9652C82.6762 73.2258 81.2129 72.1594 80.4861 70.9742C79.7592 69.7889 79.4722 68.0012 79.3629 66.5853Z",
    fill: "url(#paint1_linear_1_141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1049 17.1744L62.065 15.8608C58.0452 10.7834 56.0353 8.24474 53.697 8.61951C51.3588 8.99427 50.2407 12.0343 48.0045 18.1143L47.426 19.6873C46.7906 21.415 46.4728 22.2789 45.8635 22.913C45.2541 23.547 44.4221 23.8795 42.7581 24.5444L41.2432 25.1498L40.1794 25.5754C35.0315 27.6408 32.4375 28.8112 32.1063 31.0855C31.753 33.5114 34.2083 35.5866 39.1188 39.7371L40.3893 40.8109C41.7847 41.9903 42.4824 42.58 42.8824 43.3838C43.2823 44.1876 43.3393 45.1145 43.4531 46.9683L43.5568 48.656C43.9576 55.1795 44.1579 58.4412 46.2779 59.5657C48.3978 60.6903 51.0333 58.9328 56.3043 55.418L56.3044 55.4179L57.668 54.5086C59.1659 53.5098 59.9148 53.0103 60.7714 52.8731C61.6279 52.7358 62.4951 52.9762 64.2295 53.4569L65.8086 53.8946C71.912 55.5865 74.9637 56.4324 76.6271 54.7015C78.2906 52.9706 77.4642 49.8092 75.8113 43.4864L75.3837 41.8506C74.914 40.0539 74.6791 39.1555 74.8086 38.2669C74.938 37.3782 75.417 36.5999 76.375 35.0433L76.375 35.0433L77.2472 33.6261C80.6186 28.1482 82.3043 25.4093 81.2124 23.215C80.1206 21.0208 76.9743 20.8244 70.6817 20.4315L69.0538 20.3299C67.2656 20.2183 66.3715 20.1625 65.595 19.7505C64.8184 19.3386 64.2472 18.6172 63.105 17.1744L63.1049 17.1744Z",
    fill: "url(#paint2_linear_1_141)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.9169 57.1919C28.7443 61.6732 21.112 68.7707 18.2328 77.2519C15.0031 57.0485 19.4831 44.002 26.6644 35.8934C27.2833 37.1583 28.0874 38.2054 28.8098 39.0238C30.3114 40.7251 32.4672 42.5463 34.6562 44.3956L36.2313 45.7268C36.5299 45.9792 36.7623 46.1757 36.9597 46.3461C36.9798 46.6223 36.9997 46.9446 37.0253 47.3624L37.1533 49.446C37.3253 52.2569 37.4933 55.001 37.9169 57.1919Z",
    fill: "url(#paint3_linear_1_141)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_141",
    x1: 47.2097,
    y1: 70.403,
    x2: 47.2097,
    y2: 92.6804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_141",
    x1: 77.2506,
    y1: 66.103,
    x2: 77.2506,
    y2: 79.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_141",
    x1: 56.808,
    y1: 8.58325,
    x2: 56.808,
    y2: 59.9037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_141",
    x1: 27.5417,
    y1: 35.8934,
    x2: 27.5417,
    y2: 77.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290781"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccurateImg);
export default __webpack_public_path__ + "static/media/AccurateImg.f0248d55224a718c90e24923d508ffb0.svg";
export { ForwardRef as ReactComponent };